<template>
  <div>
    <Modal
      v-if="isOpen"
      :isOpen="isOpen"
      :save="save"
      :close="close"
      :isLastStep="valid"
      :title="'Update Speech Lab Tag'"
    >
      <v-card>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="save()"
          >
            <v-layout grid-list-xs column text-xs-center>
              <v-flex>
                <v-checkbox
                  label="Available for Free User"
                  v-model="updateData.isGuestPlayable"
                  :value="updateData.isGuestPlayable"
                  @change="
                    e => {
                      updateData.isGuestPlayable = e ? true : false;
                    }
                  "
                />
                <v-layout row wrap>
                  <v-flex>
                    <v-checkbox
                      label="Hide Content"
                      v-model="updateData.is_hide"
                      :value="updateData.is_hide"
                      @change="
                        e => {
                          updateData.is_hide = e ? true : false;
                        }
                      "
                    />
                  </v-flex>
                  <v-flex
                    ><v-text-field
                      label="Code"
                      :value="updateData.code"
                      v-model="updateData.code"
                      disabled
                    ></v-text-field
                  ></v-flex>
                </v-layout>
                <v-text-field
                  label="Tag Name"
                  :value="updateData.tag_name"
                  v-model="updateData.tag_name"
                  @input="
                    e => {
                      updateData.tag_name = e.toLowerCase().trim();
                      checkTagPhonic(e);
                    }
                  "
                  :rules="[rules.required, checkTagDicphonicExists]"
                ></v-text-field>
                <v-text-field
                  :value="updateData.display_name"
                  v-model="updateData.display_name"
                  label="Display Name"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  type="number"
                  :value="updateData.play_count"
                  v-model.number="updateData.play_count"
                  label="Play Count"
                  :rules="[rules.required, rules.isNumber]"
                ></v-text-field>
                <v-select
                  :items="constants.status"
                  label="Status"
                  item-text="name"
                  item-value="value"
                  :value="updateData.status"
                  v-model="updateData.status"
                  :rules="[rules.required]"
                ></v-select>
                <v-text-field
                  type="number"
                  :value="updateData.level"
                  v-model.number="updateData.level"
                  label="Level"
                  :rules="[rules.required, rules.isNumber]"
                ></v-text-field>
                <img class="image_thumbnail" :src="updateData.cover_image" />
                <v-text-field
                  label="Cover Image (URL or Select file)"
                  :value="updateData.cover_image"
                  v-model="updateData.cover_image"
                  :rules="[rules.validURI]"
                ></v-text-field>
                <v-btn class="btn-center" @click="isEditImage = true"
                  ><v-icon>image</v-icon>Select Cover Image URI</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </Modal>
    <ResourceSelect
      v-if="isEditImage"
      resourceType="image"
      :isShow="isEditImage"
      :close="closeEditImage"
      :save="saveEditImage"
      :value="selectImageUri"
      :onSelect="onSelectImage"
    />
  </div>
</template>

<script>
import Modal from '../../../components/Modal.vue';
import { mapActions, mapState } from 'vuex';
import rules from '../../../utils/ruleValidate';
import ResourceSelect from '../../../components/ResourceSelect';
import constants from './constants';

export default {
  components: { Modal, ResourceSelect },
  data() {
    return {
      constants,
      valid: true,
      rules,
      updateData: {},
      selectImageUri: '',
      isEditImage: false,
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      selectedSpeechLabTag: state => state.speech_lab_tag.selectedSpeechLabTag,
      checkTagDicphonicExists: state =>
        state.speech_lab_tag.checkTagDicphonicExists,
    }),
  },
  methods: {
    ...mapActions('speech_lab_tag', [
      'updateSpeechLabTag',
      'searchTagsDicphonic',
    ]),
    save() {
      if (this.$refs.form.validate()) {
        this.updateSpeechLabTag(this.updateData);
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },
    saveEditImage() {
      const uri = this.selectImageUri;
      this.updateData.cover_image = uri;
      this.closeEditImage();
    },
    closeEditImage() {
      this.selectImageUri = '';
      this.isEditImage = false;
    },
    onSelectImage(uri) {
      this.selectImageUri = uri;
    },
    checkTagPhonic(tag) {
      this.searchTagsDicphonic({ tags: [tag] });
    },
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.updateData = { ...this.selectedSpeechLabTag };
      }
    },
  },
};
</script>

<style></style>
